import React from 'react'

import { Sentiment } from '@sidecar-components/types'
import { bgCrossStyles, bgWheelStyles } from './styles'

const shapeColor: Record<Sentiment, string> = {
  [Sentiment.ACCENT]: 'color-iconOnAccent-disabled',
  [Sentiment.BRAND]: 'color-iconAccent-default',
  [Sentiment.DEFAULT]: 'color-icon-weak-default',
  [Sentiment.ENGAGE]: 'color-icon-weak-default',
  [Sentiment.ENGAGE_ON_COLOR]: 'color-icon-weak-default',
  [Sentiment.INVERSE]: 'color-icon-weak-default',
  [Sentiment.NOTIFY]: 'color-iconNotify-disabled',
  [Sentiment.POSITIVE]: 'color-iconPositive',
  [Sentiment.PRIMARY]: 'color-iconPrimary',
  [Sentiment.RISK]: 'color-iconOnRisk-weak-default',
  [Sentiment.WEAK]: 'color-icon-weak-default',
}

type BackgroundShapesProps = {
  sentiment: Sentiment
}
export const BackgroundShapes = ({ sentiment }: BackgroundShapesProps) => {
  return (
    <>
      {/* Floating cross decoration */}
      <svg
        viewBox="0 0 140 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={bgCrossStyles}
        data-testid="info_cardBackgroundShapes"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M93.3312 46.6656V0H46.6656V46.6656H0V93.3344H46.6656V140H93.3312V93.3344H140V46.6656H93.3312Z"
          className={shapeColor[sentiment] || 'color-icon-weak-default'}
        />
      </svg>

      {/* Floating wheel decoration */}
      <svg
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={bgWheelStyles}
        data-testid="info_cardBackgroundShapes"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M100 199.989C44.7703 199.989 0 155.221 0 99.9943C0 44.7678 44.7703 0 100 0C155.23 0 200 44.7678 200 99.9943C200 155.221 155.23 199.989 100 199.989V199.989ZM99.9985 141.656C123.01 141.656 141.664 123.003 141.664 99.9927C141.664 76.9824 123.01 58.3294 99.9985 58.3294C76.984 58.3294 58.3299 76.9824 58.3299 99.9927C58.3299 123.003 76.984 141.656 99.9985 141.656V141.656Z"
          className={shapeColor[sentiment] || 'color-icon-weak-default'}
        />
      </svg>
    </>
  )
}
